export default {
  components : {
  },
  watch : {
    agent() {
      console.log('agent refreshed')
    }
  },
  props: ['item'],
  methods: {
    runStatus() { return this.agent && this.agent.status && this.agent.status.running == true },
    detail: function(item) { this.$router.push(`agent/${item.id}`); },
  },
  data : () => {
    return {
      agent : {}
    }
  },
  created () { console.info('agent-item.vue created') },
  destroyed () { console.log('agent-item.vue destroyed') },
  mounted () {
    this.agent = this.item
    console.log('agent-item.vue mounted');
  },
}
